import React from "react";
import ifx_image_one from "../Images/batak_pro/1.jpeg";
import ifx_image_two from "../Images/batak_pro/2.jpeg";
import ifx_image_three from "../Images/batak_pro/3.jpeg";
import ifx_image_four from "../Images/batak_pro/4.Jpeg";
import ifx_image_five from "../Images/batak_pro/5.jpg";
import ifx_image_six from "../Images/batak_pro/6.JPG";
import ifx_image_seven from "../Images/batak_pro/7.JPG";
import "./Gallary.css";

function Gallary() {
  return (
    <div className="ifx_images_grid">
      <div className="ifx-image-one">
        <img src={ifx_image_one} alt="Image One"  />
      </div>
      <div className="ifx-image-two">
        <img src={ifx_image_two} alt="Image Two" />
      </div>
      <div className="ifx-image-three">
        <img src={ifx_image_three} alt="Image Three" />
      </div>
      <div className="ifx-image-four">
        <img src={ifx_image_four} alt="Image Four" />
      </div>
      <div className="ifx-image-five">
        <img src={ifx_image_five} alt="Image Five" />
      </div>
      <div className="ifx-image-six">
        <img src={ifx_image_six} alt="Image Six" />
      </div>
      <div className="ifx-image-seven">
        <img src={ifx_image_seven} alt="Image Seven" />
      </div>
    </div>
  );
}

export default Gallary;
